import React from 'react';
import PageContainer from 'components/Containers/PageContainer';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import CurrentPotentialPaymentGrade from 'partial/OfferManager/modules/GoalNegativeMarks/components/CurrentPotentialPaymentGrade/CurrentPotentialPaymentGrade';
import SectionContainer from 'components/Containers/SectionContainer';
import CreditUsageDials from 'components/NewCardScoreIncrease/CreditUsageDials/CreditUsageDials';
import { ReactComponent as ArrowUp } from 'style/icons/arrow-up.svg';
import { formatIncome } from 'helpers/money.helper';
import TextFromConfig from 'components/TextFromConfig';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import ActionPlan from 'components_NewCardScoreIncrease/ActionPlan/ActionPlan';
import { REDUCE_CREDIT_USAGE_WITH_LIMIT_INCREASE } from 'partial/OfferManager/module.constants';
import WhatsNext from 'components/WhatsNext/WhatsNext';
import CollapsibleComponent from 'components/CollapsibleContainer';
import OText from 'components/CText/OText';
import { CREDIT_USAGE_ACTION } from 'types/morph.pagePosition.constants';
import OffersCards from 'components/NewCardScoreIncrease/OffersCards/OffersCards';

const TooltipCreditUsage = (defaultTestId, pagePosition) => (
  <CSTooltip
    title={
      <TextFromConfig
        path={
          TextFromConfig.paths.REDUCE_CREDIT_USAGE_WITH_LIMIT_INCREASE_LIMIT
        }
      />
    }
    isInline={true}
    datatestid={defaultTestId}
    tooltipName="Potential"
    pagePosition={pagePosition}
    overlayClassName="credit-usage-tooltip"
  />
);

const CreditUsageDialsWrapper = props => (
  <CreditUsageDials
    className="padlr20 m-padlr4 m-column-gap-106 t-column-gap-112"
    width={110}
    currentCreditUsageTitle={props?.currentCreditUsageText}
    predictedCreditUsageTitle={
      <FlexContainer alignItemsCenter>
        <Label>{props?.potentialCreditUsageText}</Label>
        <TooltipCreditUsage />
      </FlexContainer>
    }
    disclaimerCopy={props?.bulbTipText}
    mobileWidth={110}
    currentCreditUsage={props?.creditUsage || '0'}
    predictedCreditUsage={props?.potentialCreditUsage}
    showBottomCopies
    bottomLeftCopy={
      <>
        <Label type="Overline" className="toUpper fontGray6 text-center">
          <OText text={props?.bottomCurrentCreditUsageText} />
        </Label>

        <FlexContainer alignItemsCenter justifyCenter>
          <Label type="H5">{formatIncome(props?.creditLimit)}</Label>
          <ArrowUp role="img" aria-label="ArrowUp" />
        </FlexContainer>
      </>
    }
    bottomRightCopy={
      <>
        <Label type="Overline" className="toUpper fontGray6 text-center">
          <OText text={props?.bottomPotentialCreditUsageText} />
        </Label>

        <FlexContainer alignItemsCenter justifyCenter>
          <Label type="H5">{formatIncome(props?.potentialLimit)}</Label>
          <ArrowUp role="img" aria-label="ArrowUp" />
        </FlexContainer>
      </>
    }
  />
);

const GoalReduceCreditUsageWithLimitIncreaseView = props => {
  const copies =
    props?.config?.goals?.[REDUCE_CREDIT_USAGE_WITH_LIMIT_INCREASE];

  return (
    <PageContainer>
      <SectionContainer>
        <FlexContainer>
          <div className="format70 m-format100 margr30 m-margr0">
            <Row>
              <Label
                type="H3"
                typeHeader={'h2'}
                datatestid={`${props?.defaultTestId}-title`}
              >
                {copies?.simulationContainer?.title}
              </Label>
            </Row>
            <Row className="m-margb0">
              <Label type="Body-1">
                {copies?.simulationContainer?.subtitle}
              </Label>
            </Row>
            <Row className="m-margb0">
              <Label type="caption">
                {copies?.simulationContainer?.description}
              </Label>
            </Row>
            <Row className="padlr30 margt20">
              <CurrentPotentialPaymentGrade
                currentPaymentTitle={
                  copies?.creditUsageGradeSimulation?.currentCreditUsageTitle
                }
                potentialPaymentTitle={
                  copies?.creditUsageGradeSimulation?.potentialCreditUsageTitle
                }
                currentPaymentHistoryGrade={props?.creditUsageGrade}
                potentialPaymentHistoryGrade={props?.potentialCreditUsageGrade}
              />
            </Row>
            <Row className="m-block desktopHide">
              <CreditUsageDialsWrapper
                {...props}
                currentCreditUsageText={
                  copies?.creditUsageSimulation?.currentCreditUsageText
                }
                potentialCreditUsageText={
                  copies?.creditUsageSimulation?.potentialCreditUsageText
                }
                bottomCurrentCreditUsageText={
                  copies?.creditUsageSimulation?.bottomCurrentCreditUsageText
                }
                bottomPotentialCreditUsageText={
                  copies?.creditUsageSimulation?.bottomPotentialCreditUsageText
                }
                bulbTipText={copies?.creditUsageSimulation?.bulbTipText}
              />
            </Row>
          </div>
          <div className="mPoof padt8">
            <Row className="padlr10">
              <CreditUsageDialsWrapper
                {...props}
                currentCreditUsageText={
                  copies?.creditUsageSimulation?.currentCreditUsageText
                }
                potentialCreditUsageText={
                  copies?.creditUsageSimulation?.potentialCreditUsageText
                }
                bottomCurrentCreditUsageText={
                  copies?.creditUsageSimulation?.bottomCurrentCreditUsageText
                }
                bottomPotentialCreditUsageText={
                  copies?.creditUsageSimulation?.bottomPotentialCreditUsageText
                }
                bulbTipText={copies?.creditUsageSimulation?.bulbTipText}
              />
            </Row>
          </div>
        </FlexContainer>
      </SectionContainer>
      <ActionPlan
        {...props}
        currentCreditUsageLimit={
          props?.creditInfo?.creditScoreAnalysis?.creditUsage?.limit * 0.1
        }
        pagePosition={CREDIT_USAGE_ACTION}
        title={copies?.actionPlanContainer?.title}
        subTitle={copies?.actionPlanContainer?.subtitle}
      />
      <WhatsNext
        sectionTitle={copies?.whatsNextContainer?.title}
        leftTitle={copies?.whatsNextContainer?.leftTitle}
        leftContent={copies?.whatsNextContainer?.leftContent}
        rightTitle={copies?.whatsNextContainer?.rightTitle}
        rightContent={copies?.whatsNextContainer?.rightContent}
      />
      <OffersCards
        credit_offers_header={copies?.offerCardsContainer.title}
        datatestid="actionsPage"
        {...props}
      />
      <SectionContainer>
        <Row className="bgWhite">
          <div tabindex="-1">
            <Label type="H4" typeHeader="h2" className="margb32" tabIndex="">
              {copies?.frequentlyAskedQuestionsContainer?.title}
            </Label>
            {copies?.frequentlyAskedQuestionsContainer?.frequentlyQuestions?.map(
              item => (
                <div key={item?.question}>
                  <div className="margT16 bgWhite"> </div>
                  <CollapsibleComponent
                    className="flex-1 bgGray0"
                    isExpanded={false}
                    contentTitle={
                      <Label className={'H5 mSubtitle-1'} tabIndex="-1">
                        {item?.question}
                      </Label>
                    }
                  >
                    <div className={'padL48 padR16 padB24 bgGray0'}>
                      <Label className={'Body-1 mBody-1'}>
                        <OText text={item.answer} />
                      </Label>
                    </div>
                  </CollapsibleComponent>
                </div>
              ),
            )}
          </div>
        </Row>
      </SectionContainer>
    </PageContainer>
  );
};

export default GoalReduceCreditUsageWithLimitIncreaseView;
